import left from './icons/leftOutline'
import qq from './icons/qqOutline'
import dropDown from './icons/dropDownOutline'
import check from './icons/checkOutline'
import backUp from './icons/backUpOutline'
import close from './icons/closeOutline'
import warning from './icons/warningOutline'

export default { left, qq, dropDown, check, backUp, close, warning }
